// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"3be2d1eb","199":"be788b55","308":"1864c305","321":"5221acdc","548":"be77a487","957":"fe1ad5c0","975":"40b801d9"}[chunkId] + ".chunk.css";
};